import { useMutation } from 'react-query';

import { setDashboard as mutationFn } from 'api/endPoints/setDashboard';

import { IDashboard } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useMutationSetDashboardById = () => {
    return useMutation<
        IDashboard,
        QueryError,
        {
            dashboard: IDashboard | undefined;
        }
    >((params) => mutationFn(params.dashboard));
};
